module.exports = __webpack_public_path__ + "img/ruanbao5.23bf9c99.jpg";